import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { BankingSettings } from '../../../models/store/BankingSettings';
import { toDayOfWeek } from '../../../enums/DayOfWeek';
import { StoreBankingSettingsResponse } from '../../../../interfaces/response/StoreResponses';

/**
 * An adapter converts store banking settings HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class BankingSettingsAdapter implements Adapter<BankingSettings[]> {

  /**
   * Converts store banking settings HTTP response to a list of {@link BankingSettings}.
   * @param item store banking settings HTTP response.
   */
  adapt(item: StoreBankingSettingsResponse[]): BankingSettings[] {
    if (!item) {
      return [];
    }

    const result: BankingSettings[] = [];
    item.forEach($item => {
      const days = $item.bankingDays.map(day => toDayOfWeek(day));
      result.push(new BankingSettings($item.date, days));
    });
    return result.sort((previous, current) => current.startDate < previous.startDate ? 1 : -1);
  }
}
